export default {"src":"/_next/static/media/emoji.a69b3f09.svg","height":219,"width":218};